import Campo from "../Shared/Campo";

const STATUS_FINALIZACAO_LABELS = {
    RESOLVIDO: "Resolvido",
    NAO_RESOLVIDO: "Não Resolvido",
};

// Dados acumulados do processo — sempre visível, independentemente da etapa atual.
export default function DetalheChamadoTI({ detalheProcesso }) {
    if (!detalheProcesso) return null;

    const camposTipoServico = detalheProcesso.camposTipoServico || [];
    const valoresCampos = detalheProcesso.valoresCampos || {};

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Dados do Chamado</h2>
                <div className="grid grid-cols-2 text-sm">
                    <Campo label="Tipo de Serviço" valor={detalheProcesso.tipoServicoNome} />
                    <Campo label="Resumo" valor={detalheProcesso.resumo} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Descrição Detalhada</h3>
                <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.descricaoDetalhada}</p>
            </div>

            {camposTipoServico.length > 0 && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">
                        Dados de "{detalheProcesso.tipoServicoNome}"
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-1  text-sm">
                        {camposTipoServico.map(campo => (
                            <Campo
                                key={campo.chave}
                                label={campo.rotulo}
                                valor={formatarValorCampo(campo, valoresCampos[campo.chave])}
                                href={campo.tipoCampo === "LOCALIZACAO" ? linkMapaOuNulo(valoresCampos[campo.chave]) : null}
                            />
                        ))}
                    </div>
                </div>
            )}

            {detalheProcesso.statusFinalizacao && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Resultado da Análise (TI)</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-2">
                        <Campo label="Status" valor={STATUS_FINALIZACAO_LABELS[detalheProcesso.statusFinalizacao] || detalheProcesso.statusFinalizacao} />
                    </div>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.solucaoAplicada}</p>
                </div>
            )}
        </div>
    );
}

function formatarValorCampo(campo, valor) {
    if (valor === undefined || valor === null || valor === "") return null;
    if (campo.tipoCampo === "BOOLEANO") return valor === "true" ? "Sim" : "Não";
    return valor;
}

function linkMapaOuNulo(valor) {
    return valor ? `https://www.google.com/maps?q=${valor}` : null;
}